import * as d3 from "d3";

import { formatDate, formatDateNumeric, parseDate } from "../../utils/parsers.js";

import React from "react";
import Button from 'react-bootstrap/Button';

class OverlapsPlot extends React.Component {
  constructor(props) {
    super(props);
    this.canvas = React.createRef();
    
    this.state = {
      data: null,
      source_list: [],
      canvas_live: false,
      popped_sources: [],
      help_on: false,
      sourceCount: 0,
      //can write these directly into code later, but keep here for now for ease of edit
      nPtWard: [],
      nWards: 0,
      nPt: 0,
      margin: { top: 20, right: 0, bottom: 80, left: 240 },
      ptHxHeight: 60,
      testHeight: 0,
      locationHeight: 0,
      overlapStart: 0,
      ptHeight: 20,
      spacer: 30,
      width: 800,
      widthScale: 1,
      height: 0,
      colors: {
        infected: "#d1615d",
        atRisk: "#5778a4",
        contam: "darkOrange",
        infected_dim: "#b3b3b3",
        atRisk_dim: "#b3b3b3",
        contam_dim: "#cccccc",
        collectdt_diamond: "mediumPurple",
        segment_highlight_border: "black",
        negative: "#5778a4",

        // Test result colors
        test_pos_toxin: "#d1615d",
        test_pos_gdh: "#ff9900",
        test_neg: "#5778a4",
        test_pos_toxin_border: "darkRed",
        test_pos_gdh_border: "darkOrange",
        test_neg_border: "#1a304d",
        test_text: "#450a0a",
        
        // UI colors
        mouse_over_color: "crimson",

        // Patient label colors
        index_patient_label: "darkRed",
        sequence_match_source_label: "purple",
        sequence_not_match_source_label: "black",
        no_sequence_data_source_label: "grey",
        normal_source_label: "black",
        highlighted_source_label: "darkBlue",

        // Tooltip colors
        tooltip_text: "white",
        tooltip_background: "#132f52",
        tooltip_border: "black",
      },
      wardColors: [
        "#f28e2b",
        "#e15759",
        "#76b7b2",
        "#59a14f",
        "#edc948",
        "#86bcb6",
        "#b07aa1",
        "#4e79a7",
        "#ff9da7",
        "#9c755f",
        "#a0cbe8",
        "#ffbe7d",
        "#8cd17d",
        "#d37295",
        "#f1ce63",
        "#d4a6c8",
        //"#d7b5a6",

        // // Tab hue:
        // "#1ba3c6",
        // "#33a65c",
        // "#f06719",
        // "#2cb5c0", 
        // "#57a337",
        // "#f64971", 
        // "#30bcad",
        // "#fc719e",
        // "#d5bb21",
        // "#f8b620",
        // "#e03426",
        // "#ce69be",
        // "#4f7cba", 
        // "#f89217",
        // "#a26dc2",
        // "#a2b627",
        // "#21b087", 
        // "#499894",


        // // "#7873c0",
        // // "#eb73b3",

      ],
    };
    this.resizeObserver = null;
    this.holdInterval = null;
    this.initialState = { ...this.state };
    this.wardMapping = [];
    this.redrawing = false;
    this.needsRedraw = false;
  }

  resetState = () => {
    this.setState(this.initialState);
  };

  componentDidMount() {
    this.initCanvas();
    this.initResizeObserver();
    // if (!document.getElementById("name-menu")) {
    //   //stop a new menu be created on every remount
    //   this.insertMenu();
    //   this.buildMenu();
    // }
    if (!document.getElementById("help-toggle")) {
      //stop help toggle be created on every remount
      //this.insertHelpToggle();
    }
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    const nameMenu = document.getElementById("name-menu");
    if (nameMenu) {
      //stop a new menu be created on every remount
      nameMenu.remove();
    }
    const infoToggle = document.getElementById("help-toggle");
    if (infoToggle) {
      //stop help toggle be created on every remound
      infoToggle.remove();
    }
    if (this.resizeObserver) {
      this.resizeObserver.disconnect(); // Stop observing when unmounting
    }
    window.removeEventListener('resize', this.handleResize);

  }

  componentDidUpdate(prevProps, prevState) {
    const propsChanged =
      prevProps.data !== this.props.data ||
      prevProps.level !== this.props.level ||
      prevProps.contam_period !== this.props.contam_period ||
      prevProps.tree_seq_ids !== this.props.tree_seq_ids ||
      prevProps.no_seq !== this.props.no_seq ||
      prevProps.survey_mode !== this.props.survey_mode ||
      prevProps.debug_survey_mode !== this.props.debug_survey_mode;

    const sizeChanged =
      this.state.width !== prevState.width ||
      this.state.widthScale !== prevState.widthScale;

    if (propsChanged || sizeChanged) {
      this.initCanvas();
    }
  }

  // Function to download JSON
  downloadJSON = () => {
    const jsonStr = JSON.stringify(this.props.data, null, 2);
    const blob = new Blob([jsonStr], { type: "application/json" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "overlaps-data.json";
    document.body.appendChild(a); // required for firefox
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  };

  handleResize = () => {
    if (this.canvas.current) {
      const parentWidth = this.canvas.current.clientWidth;
      const newWidth = Math.max(
        1,
        Math.round(parentWidth * this.state.widthScale)
      );
      if (newWidth !== this.state.width) {
        this.setState({ width: newWidth });
      }
    }
  };

  initResizeObserver = () => {
    if (this.canvas.current) {
      this.resizeObserver = new ResizeObserver(() => {
        this.handleResize();
      });
      this.resizeObserver.observe(this.canvas.current);
    }
  };

  startHold = (increment) => {
    this.clearHoldInterval(); // Prevent duplicate intervals
    this.holdInterval = setInterval(() => {
      this.changeWidthScale(increment);
    }, 120); // Adjust interval speed here (100ms)
  };

  clearHoldInterval = () => {
    if (this.holdInterval) {
      clearInterval(this.holdInterval);
      this.holdInterval = null;
    }
  };


  changeWidthScale = (increment, is_absolute=false) => {
    if (is_absolute) {
      this.setState({ widthScale: increment }, () => this.handleResize());
    } else {
      const newScale = Math.max(1.0, this.state.widthScale + increment);
      this.setState({ widthScale: newScale }, () => this.handleResize());
    }
  };

  initCanvas = async () => {
    if (!this.canvas.current) {
      return;
    }

    if (this.redrawing) {
      this.needsRedraw = true;
      return;
    }

    const measuredWidth = Math.max(
      1,
      Math.round(this.canvas.current.clientWidth * this.state.widthScale)
    );

    if (measuredWidth && measuredWidth !== this.state.width) {
      this.setState({ width: measuredWidth });
      return;
    }

    this.redrawing = true;
    this.needsRedraw = false;

    const finishRedraw = () => {
      this.redrawing = false;
      if (this.needsRedraw) {
        this.needsRedraw = false;
        this.initCanvas();
      }
    };

    d3.select(this.canvas.current).selectAll("svg").remove();
    d3.selectAll("tooltip").remove();

    try {
      await this.updateStats();

      this.svgCanvas = d3
        .select(this.canvas.current)
        .append("svg")
        .style("height", `${this.state.height + this.state.margin.bottom}px`)
        .style("width", `${this.state.width + this.state.margin.right}px`)
        .style("margin-right", "0px")
        .style("margin-left", "0px");

      const draw = () => {
        this.drawChart(this.props.data);
        finishRedraw();
      };

      if (!this.state.canvas_live) {
        this.setState({ canvas_live: true }, draw);
      } else {
        draw();
      }
    } catch (err) {
      finishRedraw();
      throw err;
    }
  };

  calculateSourceCounts = (source_list) => {
    let sourceCount = 0;
    let nPtWard = [];

    if (source_list.length > 0) {
      for (let i = 0; i < source_list.length; i++) {
        let labels = [];
        for (let source in source_list[i].sources) {
          labels = labels
            .filter((f) => f !== source_list[i].sources[source].label)
            .concat([source_list[i].sources[source].label]);
        }
        const wardCount = labels.length;
        nPtWard[i] = wardCount + (i === 0 ? 0 : nPtWard[i - 1]);
        sourceCount += wardCount;
      }
    }

    const nWards = nPtWard.length;
    const nPt = nWards > 0 ? nPtWard[nWards - 1] : 0;

    return { nPtWard, sourceCount, nWards, nPt };
  };

  updateSourceCount = (source_list) => {
    const counts = this.calculateSourceCounts(source_list);
    this.setState(counts);
    return counts;
  };

  updateStats = async () => {
    const { orderedList, wardMapping } = this.orderSourceList(
      this.props.data.source_list || [],
      this.props.data.locations || []
    );
    this.wardMapping = wardMapping;

    const counts = this.calculateSourceCounts(orderedList);

    const testHeight = this.state.ptHxHeight + 50;
    const locationHeight = testHeight + 35;
    const overlapStart = locationHeight + 125;
    const height =
      overlapStart +
      this.state.ptHeight * counts.nPt +
      counts.nWards * this.state.spacer;

    return new Promise((resolve) => {
      this.setState(
        {
          source_list: orderedList,
          ...counts,
          testHeight,
          locationHeight,
          overlapStart,
          height,
        },
        resolve
      );
    });
  };

  createWardMapping(source_list, locations) {
    // Extract wards from source_list
    const sourceListWards = new Set(source_list.map((item) => item.ward));

    // Extract wards from locations
    const locationWards = new Set(locations.map((location) => location.ward));

    // Merge unique wards from both source_list and locations
    const allUniqueWards = new Set([...locationWards, ...sourceListWards]);

    // Create the mapping from ward name to index
    const wardNameToIndexMapping = {};
    Array.from(allUniqueWards).forEach((ward, index) => {
      wardNameToIndexMapping[ward] = index;
    });

    return wardNameToIndexMapping;
  }

  getWardColor(wardName) {
    const index = this.wardMapping[wardName];
    const offset = this.props.data.pt.hospital_number;

    if (index !== undefined) {
      return this.state.wardColors[
        (index + offset) % this.state.wardColors.length
      ];
    } else {
      return "#b3b3b3"; // Grey
    }
  }

  orderSourceList = (source_list, locations) => {
    const safeLocations = locations || [];
    const safeSourceList = source_list || [];
    const patientWardNames = new Set(
      safeLocations.map((location) => location.ward)
    );

    // Find the earliest start time for each ward
    const earliestStartTimes = {};
    safeLocations.forEach((location) => {
      if (
        !earliestStartTimes[location.ward] ||
        location.start < earliestStartTimes[location.ward]
      ) {
        earliestStartTimes[location.ward] = location.start;
      }
    });

    const patientWards = [];
    const otherWards = [];

    safeSourceList.forEach((ward) => {
      if (patientWardNames.has(ward.ward)) {
        patientWards.push(ward);
      } else {
        otherWards.push(ward);
      }
    });

    patientWards.sort((a, b) => {
      return earliestStartTimes[a.ward] - earliestStartTimes[b.ward];
    });

    otherWards.sort((a, b) => a.ward.localeCompare(b.ward));

    const orderedList = [...patientWards, ...otherWards];

    return {
      orderedList,
      wardMapping: this.createWardMapping(orderedList, safeLocations),
    };
  };

  generateHeaderTxt(pt) {
    const text =
      pt.name + "," + pt.hospital_number + ", " + formatDate(parseDate(pt.dob));
    return text;
  }

  descrFirstPositive(pt) {
    const first_pos_day = pt.day_adm_first_positive;
    const first_pos_date = pt.first_positive;
    if (first_pos_day) {
      if (first_pos_day >= 0) {
        return (
          "First positive: " +
          formatDate(parseDate(first_pos_date)) +
          " (day " +
          first_pos_day +
          " post first admission while at risk)"
        );
      } else {
        return (
          "First positive: " +
          formatDate(parseDate(first_pos_date)) +
          " (" +
          -1 * first_pos_day +
          " days before first admission following while at risk)"
        );
      }
    } else {
      return (
        "First positive: " +
        d3.timeFormat(parseDate(first_pos_date)) +
        " (no admissions in at risk period)"
      );
    }
  }

  drawHeaderBlocks(pt) {
    //const svgCanvas = d3.select(this.canvas.current);
    this.svgCanvas
      .append("text")
      .attr("x", 10)
      .attr("y", 18)
      .attr("font-size", 18)
      .style("text-anchor", "start")
      .attr("font-weight", 500)
      .text(this.generateHeaderTxt(pt));

    this.svgCanvas
      .append("text")
      .attr("x", 10)
      .attr("y", 36)
      .attr("font-size", 14)
      .style("text-anchor", "start")
      .text(this.descrFirstPositive(pt));
  }

  drawXAxis(pt) {
    /*if (this.state.help_on) {
      var x = d3
        .scaleTime()
        .domain([pt.plot_start - 24 * 60 * 60 * 1000, pt.plot_end])
        .range([this.state.margin.left, this.state.width - 70]);*/
    //} else {
    var x = d3
      .scaleTime()
      .domain([pt.plot_start - 24 * 60 * 60 * 1000, pt.plot_end])
      .range([this.state.margin.left, this.state.width]);
    //}
    this.x = x;
    this.svgCanvas
      .append("g")
      .attr("transform", "translate(0," + this.state.height + ")")
      .call(d3.axisBottom(x).tickFormat(d3.timeFormat("%d %b")))
      .selectAll("text")
      .attr("transform", "translate(-10,0)rotate(-45)")
      .attr("font-size", 14)
      .style("text-anchor", "end");

    // // Add grid lines for x-axis
  const timeRangeDay = d3.timeDay.range(pt.plot_start, pt.plot_end, 1);  // one day step
  this.svgCanvas
    .selectAll(".x-grid-line")
    .data(timeRangeDay)
    .enter()
    .append("line")
    .attr("class", "x-grid-line")
    .attr("x1", (d) => x(d))
    .attr("x2", (d) => x(d))
    .attr("y1", this.state.locationHeight + 15 + this.state.ptHeight * 2)
    .attr("y2", this.state.height)
    .attr("stroke", "rgba(0, 0, 0, 0.07)");

  const timeRangeWeek = d3.timeWeek.range(pt.plot_start, pt.plot_end, 1);  // one week step
  this.svgCanvas
    .selectAll(".x-grid-line-week")
    .data(timeRangeWeek)
    .enter()
    .append("line")
    .attr("class", "x-grid-line-week")
    .attr("x1", (d) => x(d))
    .attr("x2", (d) => x(d))
    .attr("y1", this.state.locationHeight + 15 + this.state.ptHeight * 2)
    .attr("y2", this.state.height)
    .attr("stroke", "rgba(0, 0, 0, 0.2)");
  }

  drawPtAtRisk(pt) {
    if (pt.at_risk_end > pt.plot_start) {
      this.svgCanvas
        .append("rect")
        .attr("x", this.x(pt.at_risk_start))
        .attr("y", this.state.ptHxHeight + this.state.ptHeight / 4)
        .attr("width", this.x(pt.at_risk_end) - this.x(pt.at_risk_start) + "px")
        .attr("height", this.state.ptHeight / 2)
        .attr("fill", this.state.colors.atRisk);
      this.svgCanvas
        .append("text")
        .attr(
          "x",
          this.x(pt.at_risk_start) +
            (this.x(pt.at_risk_end) - this.x(pt.at_risk_start)) / 2
        )
        .attr("y", this.state.ptHxHeight - 3)
        .attr("font-size", 14)
        .style("text-anchor", "middle")
        .text("Incubation (At Risk) Period");
    }
    this.svgCanvas
      .append("text")
      .attr("x", this.x(pt.at_risk_start) - 65)

      .attr("y", this.state.ptHxHeight + this.state.ptHeight / 1.3)
      .attr("font-size", 14)
      .style("text-anchor", "end")
      .style("font-weight", 400)
      .style("fill", this.state.colors.index_patient_label)
      .text(pt.name + ", " + pt.hospital_number);
    this.svgCanvas
      .append("line")
      .attr("x1", this.x(pt.at_risk_start) - 9)
      .attr("y1", this.state.ptHxHeight + this.state.ptHeight / 2)
      .attr("x2", this.x(pt.at_risk_start) - 60)
      .attr("y2", this.state.ptHxHeight + this.state.ptHeight / 2)
      .attr("stroke", "black")
      .attr("opacity", 0.7)
      .attr("stroke-width", 1);
  }

  drawPtInfectious(pt) {
    this.svgCanvas
      .append("rect")
      .attr("x", this.x(pt.inf_start))
      .attr("y", this.state.ptHxHeight)
      .attr("width", this.x(pt.plot_end) - this.x(pt.inf_start) + "px")
      .attr("height", this.state.ptHeight)
      .attr("fill", this.state.colors.infected);
    this.svgCanvas
      .append("text")
      // .attr(
      //   "x",
      //   this.x(pt.inf_start) + (this.x(pt.plot_end) - this.x(pt.inf_start)) / 2
      // )
      .attr("x", this.x(pt.plot_end))
      .attr("y", this.state.ptHxHeight - 5)
      .attr("font-size", 14)
      .style("text-anchor", "end")
      .text("Infected");
  }

  sourceHeaderBlock() {
    //console.log(this.state.source_list);

    const uniquePatients = new Set();
    this.state.source_list.forEach((ward) => {
      ward.sources.forEach((patient) => {
        uniquePatients.add(patient.pid);
      });
    });

    this.svgCanvas
      .append("text")
      .attr("x", 20)
      .attr("y", this.state.overlapStart - this.state.spacer - 20)
      .attr("font-size", 16)
      .attr("font-weight", 500)
      .style("text-anchor", "start")
      .text("Potential Source(s):");
    this.svgCanvas
      .append("text")
      .attr("x", 20)
      .attr("y", this.state.overlapStart - this.state.spacer)
      .attr("font-size", 14)
      .attr("font-weight", 400)
      .style("text-anchor", "start")
      .text(
        uniquePatients.size +
          " unique patient(s) found in " +
          this.state.source_list.length +
          " ward(s)"
      );
  }

  reorderWards = async (ward_arr, ward_index, source_index) => {
    var target_arr = [];
    let index_0 = ward_arr[ward_index]; // ward to be moved to front of arr
    index_0 = await this.reorderSources(index_0, source_index); //reorder sources within that ward
    ward_arr.splice(ward_index, 1);
    target_arr.push(index_0); //reconstruct arr with target ward at the front
    for (let i = 0; i < ward_arr.length; i++) {
      target_arr.push(ward_arr[i]);
    }
    let nPtWard = [];
    for (let i = 0; i < target_arr.length; i++) {
      if (i === 0) {
        nPtWard[i] = target_arr[i].sources.length;
      } else {
        nPtWard[i] = target_arr[i].sources.length + nPtWard[i - 1];
      }
    }
    this.setState({
      source_list: target_arr,
    });
    // update source count for correct y axis spacing
    this.updateSourceCount(target_arr);
  };

  reorderSources = (ward_obj, source_index) => {
    let source_arr = ward_obj.sources;
    var target_list = [];
    let index_0 = source_arr[source_index];
    source_arr.splice(source_index, 1);
    target_list.push(index_0);
    for (let i = 0; i < source_arr.length; i++) {
      target_list.push(source_arr[i]);
    }
    ward_obj["sources"] = target_list;
    return ward_obj;
  };

  popSource = (ward_arr, ward_index, source_index) => {
    const popped_source = ward_arr[ward_index].sources[source_index];
    ward_arr[ward_index].sources.splice(source_index, 1);
    let nPtWard = [];
    for (let i = 0; i < ward_arr.length; i++) {
      if (i === 0) {
        nPtWard[i] = ward_arr[i].sources.length;
      } else {
        nPtWard[i] = ward_arr[i].sources.length + nPtWard[i - 1];
      }
    }
    this.setState({
      popped_sources: [...this.state.popped_sources, popped_source],
      source_list: ward_arr,
    });
    // update source count for correct y axis spacing

    this.updateSourceCount(ward_arr);
  };

  constructWardBlocks(pt, locations) {
    for (let i = 0; i < this.state.nWards; i++) {
      var y_spacing = this.calcYAxSpacing(i);
      var y = this.drawYAxis(this.state.source_list, i, y_spacing);
      var tooltip = d3
        .select("body")
        .append("tooltip")
        .style("opacity", 0)
        .style("background-color", this.state.colors.tooltip_background)
        .style("border-radius", "5px")
        .style("border-color", this.state.colors.tooltip_border)
        .style("padding", "5px")
        .style("color", this.state.colors.tooltip_text)
        .style("position", "absolute")
        .style("font-size", "13px")
        .style("height", 0);
      // Draw contamination first (lowest layer)
      this.state.source_list[i].sources.forEach((source) => {
        if (this.x(source.inf_bar_end) !== this.x(pt.plot_end)) {
          this.drawSrceContam(source, pt, y, this.x, pt.plot_start, tooltip);
        }
      });

      // Draw infected, at risk & collection date
      this.state.source_list[i].sources.forEach((source) => {
        if (source.risk_bar_end > source.risk_bar_start) {
          this.drawSrceAtRisk(source, pt, y, tooltip, i);
        }
        if (source.inf_bar_end > source.inf_bar_start) {
          this.drawSrceInfected(source, pt, y, tooltip, i);
        }
        if (source.collectdt <= pt.plot_end && source.collectdt >= pt.plot_start) {
          this.drawSrceCollectDt(source, y, this.x);
        }
      });
      
      // Draw overlay last (highest layer)
      // Only if level = ward
      if (this.props.level === "ward") {
        this.state.source_list[i].sources.forEach(source => {
          const pt_ward_end = locations
            .filter(location => location.ward === source.ward)
            .reduce((max, location) => (!max || location.end > max.end) ? location : max, null);
    
          const pt_ward_start = locations
            .filter(location => location.ward === source.ward)
            .reduce((min, location) => (!min || location.start < min.start) ? location : min, null);
    
          if (pt_ward_end && pt_ward_start) {
            this.drawSrceWardOverlay(pt, pt_ward_start.start, pt_ward_end.end, source, y, this.x);
          }
        });
      }
      this.wardHeaderBlock(this.state.source_list, i, y_spacing);

      this.state.source_list[i].sources.forEach((source) => {
        this.drawSrcePlotOverlay(pt, y, source);
      });
    }
  }

  calcYAxSpacing(ward_no) {
    if (ward_no === 0) {
      var yWard = [
        this.state.overlapStart,
        this.state.overlapStart +
          this.state.nPtWard[ward_no] * this.state.ptHeight,
      ];
    } else {
      var yWard = [
        this.state.overlapStart +
          ward_no * this.state.spacer +
          this.state.nPtWard[ward_no - 1] * this.state.ptHeight,
        this.state.overlapStart +
          ward_no * this.state.spacer +
          this.state.nPtWard[ward_no] * this.state.ptHeight,
      ];
    }
    return yWard;
  }

  wardHeaderBlock(source_list, ward_no, y_spacing) {
    let self = this;
    // const wardName = source_list[ward_no].ward;
    // const wardColor = this.state.wardColors[ward_no % this.state.wardColors.length]; // This assumes there are more wards than colors, and repeats colors as necessary.
    const wardName = source_list[ward_no].ward;
    const wardColor = this.getWardColor(wardName);

    //console.log(source_list);
  
    const specialtyName = source_list[ward_no]?.sources[0]?.specialty || "Unknown"; // need to check if it's defined at each level
    const hospitalName = source_list[ward_no]?.sources[0]?.hospital || "Unknown"; // need to check if it's defined at each level

    var tooltip = d3
      .select("body")
      .append("tooltip")
      .style("opacity", 0)
      .style("background-color", this.state.colors.tooltip_background)
      .style("border-radius", "5px")
      .style("border-color", this.state.colors.tooltip_border)
      .style("padding", "5px")
      .style("color", this.state.colors.tooltip_text)
      .style("position", "absolute")
      .style("font-size", "12.5px")
      .style("height", 0);
    
    // Draw colored dot before the ward name
    this.svgCanvas
      .append("circle")
      .attr("class", "location_dot")
      .attr("ward_id", wardName)
      .attr("cx", 25)
      .attr("cy", y_spacing[0] - 10)
      .attr("r", 5)
      .style("fill", wardColor)
      .on("mousemove", function (event, d) {
        tooltip
          .style("left", event.pageX + 10 + "px")
          .style("top", event.pageY + 20 + "px");
      })
      .on("mouseover", function (event, d) {
        self.highlightWardSegments(wardName);
        tooltip
          .html("<b>" + wardName + "</b><br>Specialty: " + specialtyName + "<br>Hospital: " + hospitalName)
          .style("opacity", 0.9)
          .style("height", "auto");
      })
      .on("mouseleave", function (event, d) {
        self.clearWardHighlight();
        tooltip.style("opacity", 0).style("height", 0);
      });

      var wardNameText = "";
      if (wardName.length > 32) {
        wardNameText = wardName.substring(0, 32) + "...";
      } else {
        wardNameText = wardName;
      }

    this.svgCanvas
      .append("text")
      .attr("class", "location_text")
      .attr("ward_id", wardName)
      .attr("x", 37)
      .attr("y", y_spacing[0] - 5)
      .attr("font-size", 14)
      .style("text-anchor", "start")
      .attr("font-weight", 500)
      .style("position", "fixed")
      .style("z-index", 1000)
      .text(wardNameText)
      .on("mouseover", function (event, d) {
        self.highlightWardSegments(wardName);
      })
      .on("mouseleave", function (event, d) {
        self.clearWardHighlight();
      });
  }

  drawYAxis(source_list, ward_no, y_spacing) {
    let self = this;
    var y = d3
      .scaleBand()
      .range(y_spacing)
      .domain(
        source_list[ward_no].sources.map(function (d) {
          return d.label;
        })
      )
      .padding(0.1);

    // Append Y-axis
    var yAxis = this.svgCanvas
      .append("g")
      .call(d3.axisLeft(y))
      .attr("transform", `translate(${this.state.margin.left},0)`)
      .attr("font-size", 14);

    // Change color of Y-axis labels
    const setLabelColor = (d) => {
      const source = source_list[ward_no].sources.find(
        (source) => source.label === d
      );
      const seqId =
        source && source.seq_id !== null && source.seq_id !== undefined
          ? String(source.seq_id)
          : null;

      if (seqId !== null &&
          this.props.tree_seq_ids.includes(seqId) &&
          this.props.survey_mode >= 3 &&
          this.props.debug_survey_mode >= 3) {
        return this.state.colors.sequence_match_source_label;
      } else if (this.props.no_seq.includes(d.split(", ")[0]) &&
                this.props.survey_mode >= 3 &&
                this.props.debug_survey_mode >=3) {
        return this.state.colors.no_sequence_data_source_label;
      } else {
        return this.state.colors.sequence_not_match_source_label;
      }
    };

    yAxis
      .selectAll("text")
      .style("font-weight", 400)
      .attr("class", "source_text")
      .attr("source_id", (d) => {
        return source_list[ward_no].sources.find((source) => source.label === d)
          .pid;
      })
      .attr("ward_id", source_list[ward_no].ward)
      .attr("orig_color", setLabelColor)
      .style("fill", setLabelColor)
      .on("mouseover", function (event, d) {
        self.highlightSourceSegments(d3.select(this).attr("source_id"));
      })
      .on("mouseleave", function (event, d) {
        self.clearSourceHighlight();
      });

    return y;
  }

  clickSource(source_list) {
    this.svgCanvas
      .selectAll(".tick")
      .style("cursor", "pointer")
      .on("click", (d) => {
        var pid = d.srcElement.__data__.split(", ")[1];
        for (const { ward, sources } of source_list) {
          for (const source of sources) {
            if (source.pid.toString() === pid) {
              this.props.navigate(`/patient/${source.micro_id}`);
            }
          }
        }
      });
  }

  highlightSourceSegments(source) {
    // Apply highlight style to segments with the same source
    d3.selectAll(`[source_id='${source}']:not(.source_text):not(.collectdt-diamond):not(.collectdt-diamond-plus)`)
      .style("stroke", this.state.colors.segment_highlight_border)
      .style("stroke-width", 1.5)
      .style("stroke-opacity", 0.7);

    d3.selectAll(`.source_text[source_id='${source}']`)
      //.style("font-weight", 600)
      .style("fill", this.state.colors.highlighted_source_label);

    d3.selectAll(`.collectdt-diamond[source_id='${source}']`).style(
      "opacity",
      1
    );
    d3.selectAll(`.collectdt-diamond-plus[source_id='${source}']`).style(
      "opacity",
      1
    );

    // Dim other segments
    d3.selectAll(`.source_inf:not([source_id='${source}'])`)
      .style("opacity", 1)
      .style("fill", this.state.colors.infected_dim);
    d3.selectAll(`.source_risk:not([source_id='${source}'])`)
      .style("opacity", 1)
      .style("fill", this.state.colors.atRisk_dim);
    d3.selectAll(`.source_contam:not([source_id='${source}'])`)
      .style("opacity", 1)
      .style("fill", this.state.colors.contam_dim);
  }

  clearSourceHighlight() {
    // Reset styles for all segments
    d3.selectAll(".source_inf")
      .style("stroke", "none")
      .style("opacity", 1)
      .style("fill", this.state.colors.infected);
    d3.selectAll(".source_risk")
      .style("stroke", "none")
      .style("opacity", 1)
      .style("fill", this.state.colors.atRisk);
    d3.selectAll(".source_contam")
      .style("stroke", "none")
      .style("opacity", 1)
      .style("fill", this.state.colors.contam);
    d3.selectAll(`.collectdt-diamond`).style("opacity", 0);
    d3.selectAll(`.collectdt-diamond-plus`).style("opacity", 0);

    d3.selectAll(
      `.source_text[orig_color='${this.state.colors.sequence_match_source_label}']`
    )
      //.style("font-weight", 400)
      .style("fill", this.state.colors.sequence_match_source_label);
    d3.selectAll(
      `.source_text[orig_color='${this.state.colors.no_sequence_data_source_label}']`
    )
      //.style("font-weight", 400)
      .style("fill", this.state.colors.no_sequence_data_source_label);
    d3.selectAll(
      `.source_text[orig_color='${this.state.colors.sequence_not_match_source_label}']`
    )
      //.style("font-weight", 400)
      .style("fill", this.state.colors.sequence_not_match_source_label);
  }

  highlightWardSegments(ward) {
    // Apply highlight style to segments with the same ward
    d3.selectAll(
      `[ward_id='${ward}']:not(.location_text):not(.source_text):not(.collectdt-diamond):not(.collectdt-diamond-plus):not(.ward_overlay)`
    )
      .style("stroke", this.state.colors.segment_highlight_border)
      .style("stroke-width", 1.5)
      .style("stroke-opacity", 0.7);
    d3.selectAll(
      `[ward='${ward}']:not(.location_text):not(.source_text):not(.collectdt-diamond):not(.collectdt-diamond-plus)`
    )
      .style("stroke", this.state.colors.segment_highlight_border)
      .style("stroke-width", 1.5)
      .style("stroke-opacity", 0.7);
    d3.selectAll(`.location_text[ward_id='${ward}']`)
      //.style("font-weight", 700)
      .style("fill", this.state.colors.highlighted_source_label);
    d3.selectAll(`.source_text[ward_id='${ward}']`)
      //.style("font-weight", 600)
      .style("fill", this.state.colors.highlighted_source_label);
    d3.selectAll(`.collectdt-diamond[ward_id='${ward}']`).style("opacity", 1);
    d3.selectAll(`.collectdt-diamond-plus[ward_id='${ward}']`).style("opacity", 1);
    d3.selectAll(`.ward_overlay[ward_id='${ward}']`).style("opacity", 0.6);

    // Dim other segments
    d3.selectAll(`.source_inf:not([ward_id='${ward}'])`)
      .style("opacity", 1)
      .style("fill", this.state.colors.infected_dim);
    d3.selectAll(`.source_risk:not([ward_id='${ward}'])`)
      .style("opacity", 1)
      .style("fill", this.state.colors.atRisk_dim);
    d3.selectAll(`.source_contam:not([ward_id='${ward}'])`)
      .style("opacity", 1)
      .style("fill", this.state.colors.contam_dim);
  }

  clearWardHighlight() {
  // Reset styles for all segments
  d3.selectAll(".source_inf")
    .style("stroke", "none")
    .style("opacity", 1)
    .style("fill", this.state.colors.infected);
  d3.selectAll(".source_risk")
    .style("stroke", "none")
    .style("opacity", 1)
    .style("fill", this.state.colors.atRisk);
  d3.selectAll(".source_contam")
    .style("stroke", "none")
    .style("opacity", 1)
    .style("fill", this.state.colors.contam);
  d3.selectAll(".collectdt-diamond")
    .style("opacity", 0);
  d3.selectAll(".collectdt-diamond-plus")
    .style("opacity", 0);
  d3.selectAll(`.ward_overlay`)
      .style("opacity", 0);
  d3.selectAll(".location_bar")
      .style("stroke", "none")
  d3.selectAll(".location_dot")
      .style("stroke", "none")
      .style("opacity", 1);
  d3.selectAll(".location_text")
      //.style("font-weight", 500)
      .style("fill", this.state.colors.normal_source_label);
    d3.selectAll(
      `.source_text[orig_color='${this.state.colors.sequence_match_source_label}']`
    )
      //.style("font-weight", 400)
      .style("fill", this.state.colors.sequence_match_source_label);
    d3.selectAll(
      `.source_text[orig_color='${this.state.colors.no_sequence_data_source_label}']`
    )
      //.style("font-weight", 400)
      .style("fill", this.state.colors.no_sequence_data_source_label);
    d3.selectAll(
      `.source_text[orig_color='${this.state.colors.sequence_not_match_source_label}']`
    )
      //.style("font-weight", 400)
      .style("fill", this.state.colors.sequence_not_match_source_label);
  }

  drawSrceAtRisk(source, pt, y, tooltip, ward_index, source_index) {
    let x = this.x;
    let self = this;
    var timeout = null;

    const daysAgo = -Math.round((new Date(source.collectdt) - new Date(pt.first_positive)) / (1000 * 60 * 60 * 24));

    this.svgCanvas
      .append("rect")
      .attr("class", "source_risk")
      .attr("source_id", source.pid)
      .attr("ward_id", source.ward)
      .attr("id", "source_risk_" + ward_index + "_" + source_index)

      .attr("x", x(source.risk_bar_start))
      .attr("y", y(source.label) + y.bandwidth() / 4)
      .attr(
        "width",
        x(source.risk_bar_end) - x(source.risk_bar_start) + 1 + "px"
      )
      .attr("height", y.bandwidth() / 2 + "px")
      .attr("fill", this.state.colors.atRisk)
      .on("mousemove", function (event, d) {
        tooltip
          .style("left", event.pageX + 10 + "px")
          .style("top", event.pageY + 20 + "px");
      })
      .on("mouseleave", function (event, d) {
        self.clearSourceHighlight();
        tooltip.style("opacity", 0).style("height", 0);
      })
      .on("mouseover", function (event, d) {
        self.highlightSourceSegments(d3.select(this).attr("source_id"));
        tooltip
          .html("<b>" + source.firstname + " " + source.surname + "</b> (" + source.pid + ")" +
            "<br>Location: " + source.ward + " <b><font color=#94aac7> [At Risk]</font></b>" +
            "<br>Tested: " + formatDateNumeric(source.collectdt, "yyyy-MM-dd") + " <font color=yellow>(" + daysAgo + " days ago)</font>" + (source.seq_id? "<br>Sequencing ID: " + source.seq_id : "<br>No sequencing data"))
          .style("opacity", 0.9)
          .style("height", "auto");
      });
    // .on("click", () => {
    //   clearTimeout(timeout);
    //   timeout = setTimeout(() => {
    //     this.reorderWards(this.state.source_list, ward_index, source_index);
    //   }, 200);
    // })
    // .on("dblclick", () => {
    //   clearTimeout(timeout);
    //   this.popSource(this.state.source_list, ward_index, source_index);
    // })
    // .style("cursor", "pointer");

    // Additional rectangles to fill top and bottom so other plots don't show through
    this.svgCanvas
      .append("rect")
      .attr("x", x(source.risk_bar_start))
      .attr("y", y(source.label))
      .attr("width", x(source.risk_bar_end) - x(source.risk_bar_start) + 1)
      .attr("height", y.bandwidth() / 4)
      .attr("fill", "white")
      .style("pointer-events", "none");

    this.svgCanvas
      .append("rect")
      .attr("x", x(source.risk_bar_start))
      .attr("y", y(source.label) + (3 * y.bandwidth()) / 4)
      .attr("width", x(source.risk_bar_end) - x(source.risk_bar_start) + 1)
      .attr("height", y.bandwidth() / 4)
      .attr("fill", "white")
      .style("pointer-events", "none");
  }

  drawSrceInfected(source, pt, y, tooltip, ward_index, source_index) {
    //console.log('source', source);
    let x = this.x;
    let self = this;
    var timeout = null;
    const daysAgo = -Math.round((new Date(source.collectdt) - new Date(pt.first_positive)) / (1000 * 60 * 60 * 24));
    this.svgCanvas
      .append("rect")
      .attr("class", "source_inf")
      .attr("source_id", source.pid)
      .attr("ward_id", source.ward)
      .attr("id", "source_inf_" + ward_index + "_" + source_index)
      .attr("x", x(source.inf_bar_start))
      .attr("y", y(source.label))
      .attr("width", x(source.inf_bar_end) - x(source.inf_bar_start) + "px")
      .attr("height", y.bandwidth())

      .attr("fill", this.state.colors.infected)
      .style("position", "relative")

      .style("z-index", 10) // Set the z-index

      .on("mousemove", function (event, d) {
        tooltip
          .style("left", event.pageX + 10 + "px")
          .style("top", event.pageY + 20 + "px");
      })
      .on("mouseleave", function (event, d) {
        self.clearSourceHighlight();
        tooltip.style("opacity", 0).style("height", 0);
      })
      .on("mouseover", function (event, d) {
        self.highlightSourceSegments(d3.select(this).attr("source_id"));
        tooltip
          .html("<b>" + source.firstname + " " + source.surname + "</b> (" + source.pid + ")" +
            "<br>Location: " + source.ward + " <b><font color=#db8380> [Infected]</font></b>" +
            "<br>Tested: " + formatDateNumeric(source.collectdt, "yyyy-MM-dd") + " <font color=yellow>(" + daysAgo + " days ago)</font>" + (source.seq_id? "<br>Sequencing ID: " + source.seq_id : "<br>No sequencing data"))
          .style("opacity", 0.9)
          .style("height", "auto");
    });
    // .on("click", () => {
    //   clearTimeout(timeout);
    //   timeout = setTimeout(() => {
    //     this.reorderWards(this.state.source_list, ward_index, source_index);
    //   }, 200);
    // })
    // .on("dblclick", () => {
    //   clearTimeout(timeout);
    //   this.popSource(this.state.source_list, ward_index, source_index);
    // })
    // .style("cursor", "pointer");
  }

  drawSrceCollectDt(source, y, x) {
    let self = this;
    if (source.collectdt) {
      this.svgCanvas
        .append("path")
        .attr("d", d3.symbol().type(d3.symbolCircle).size(100))
        .attr(
          "transform",
          `translate(${x(source.collectdt)},${
            y(source.label) + y.bandwidth() / 2
          })`
        )
        .attr("fill", this.state.colors.infected)
        .attr("stroke", this.state.colors.test_text)
        .attr("stroke-width", 1)
        .attr("opacity", 0)
        .attr("class", "collectdt-diamond")
        .attr("source_id", source.pid)
        .attr("ward_id", source.ward)
        .style("pointer-events", "none");

        //append a + sign to the centre of the diamond
        this.svgCanvas
        .append("text")
        .attr(
          "transform",
          `translate(${x(source.collectdt)},${
            y(source.label) + y.bandwidth() / 2 + 3
          })`
        )
        .attr("font-size", 10)
        .attr("fill", this.state.colors.test_text)
        .attr("opacity", 0)
        .attr("class", "collectdt-diamond-plus")
        .attr("source_id", source.pid)
        .attr("ward_id", source.ward)
        .style("text-anchor", "middle")
        .style("pointer-events", "none")
        .text("+");
    }
  }

  // drawSrceContam(source, y, x, plot_start, tooltip) {
  //   // Calculate the coordinates for the triangle
  //   var triangleX = x(source.inf_bar_end); // X-coordinate at the end of the infectious bar
  //   var triangleY = y(source.label) + y.bandwidth() / 2; // Y-coordinate in the middle of the source label
  //   var triangleHeight = y.bandwidth();
  //   var triangleBase = (this.props.contam_period * 56) / 7;

  //   if (x(source.inf_bar_end) < x(plot_start)) {
  //     //if start of triangle is before start of plot
  //     //Here we chop triangle. If overflowing off plot, we use a white rectangle block
  //     //Had to do it this way as Z-index on axis labels had no effect, so triangle was on top
  //     const angle = Math.atan(triangleBase / (triangleHeight / 2));
  //     triangleBase = triangleBase - (x(plot_start) - x(source.inf_bar_end));
  //     triangleHeight = 2 * (triangleBase / Math.tan(angle));
  //     triangleX = x(plot_start);
  //   }

  //   // Define the points for the triangle
  //   const points = [
  //     triangleX + "," + (triangleY - triangleHeight / 2), // Top point
  //     triangleX + "," + (triangleY + triangleHeight / 2), // Bottom-left point
  //     triangleX + triangleBase + "," + triangleY, // Bottom-right point
  //   ];

  //   // Create the triangle using a polygon element
  //   this.svgCanvas
  //     .append("polygon")
  //     .attr("points", points.join(" "))
  //     .style("position", "fixed")
  //     .style("z-index", 0) // Set the z-index

  //     .attr("fill", "darkOrange")
  //     .style("cursor", "pointer")

  //     .on("mousemove", function (event, d) {
  //       tooltip
  //         .style("left", event.pageX + 10 + "px")
  //         .style("top", event.pageY + 20 + "px");
  //     })
  //     .on("mouseleave", function (event, d) {
  //       tooltip.style("opacity", 0).style("height", 0);
  //     })
  //     .on("mouseover", function (event, d) {
  //       tooltip
  //         .html(source.firstname + " " + source.surname)
  //         .style("opacity", 0.6)
  //         .style("height", "auto");
  //     });
  // }

  // New drawSrceContam function - draws tapering shape for contamination period
  drawSrceContam(source, pt, y, x, plot_start, tooltip) {
    let self = this;

    const contamEnd = new Date(
      source.inf_bar_end + this.props.contam_period * 24 * 60 * 60 * 1000
    );
    // Calculate the coordinates for the triangle
    var triangleX = x(source.inf_bar_end); // X-coordinate at the end of the infectious bar
    var triangleY = y(source.label); // Y-coordinate in the middle of the source label
    var triangleHeight = y.bandwidth();
    var triangleBase = x(contamEnd) - x(source.inf_bar_end);
    var maxHeight = y.bandwidth(); // Height of the band

    if (x(source.inf_bar_end) < x(plot_start)) {
      //if start of triangle is before start of plot
      //Here we chop triangle. If overflowing off plot, we use a white rectangle block
      //Had to do it this way as Z-index on axis labels had no effect, so triangle was on top
      const angle = Math.atan(triangleBase / (triangleHeight / 2));
      triangleBase = triangleBase - (x(plot_start) - x(source.inf_bar_end));
      triangleHeight = 2 * (triangleBase / Math.tan(angle));
      triangleX = x(plot_start);
      triangleY = y(source.label) + y.bandwidth() / 2 - triangleHeight / 2;
      maxHeight = triangleHeight;
    }

    // Define the path for the upper and lower edges of the exponentially tapering shape
    let upperPath = `M ${triangleX} ${triangleY}`;
    let lowerPath = `L ${triangleX} ${triangleY + triangleHeight}`;

    const segments = 50; // Number of segments (higher = smoother shape)
    const taperFactor = 0.06; // Rate of tapering (higher = faster tapering)
    for (let i = 1; i <= segments; i++) {
      let decreaseFactor = Math.exp(-i * taperFactor);
      // Calculate the position along the length of the shape
      let currentX = triangleX + (triangleBase * i) / segments;
      // Calculate the height decrease from the center line
      let deltaY = (triangleHeight / 2) * decreaseFactor;
      // Calculate upper and lower Y coordinates
      let upperY = triangleY + maxHeight / 2 - deltaY;
      let lowerY = triangleY + maxHeight / 2 + deltaY;
      // Append to paths
      upperPath += ` L ${currentX} ${upperY}`;
      lowerPath = `L ${currentX} ${lowerY} ` + lowerPath;
    }
    // Combine the paths to complete the shape
    let path = upperPath + " " + lowerPath + " Z";

    const daysAgo = -Math.round((new Date(source.collectdt) - new Date(pt.first_positive)) / (1000 * 60 * 60 * 24));

    // Draw the path
    this.svgCanvas
      .append("path")
      .attr("class", "source_contam")
      .attr("source_id", source.pid)
      .attr("ward_id", source.ward)
      .attr("d", path)
      .attr("fill", this.state.colors.contam)
      .on("mousemove", function (event, d) {
        tooltip
          .style("left", event.pageX + 10 + "px")
          .style("top", event.pageY + 20 + "px");
      })
      .on("mouseover", function (event, d) {
        self.highlightSourceSegments(d3.select(this).attr("source_id"));
        tooltip
          .html("<b>" + source.firstname + " " + source.surname + "</b> (" + source.pid + ")" +
            "<br>Location: " + source.ward + " <b><font color=darkOrange> [Contaminated]</font></b>" +
            "<br>Tested: " + formatDateNumeric(source.collectdt, "yyyy-MM-dd") + " <font color=yellow>(" + daysAgo + " days ago)</font>" + (source.seq_id? "<br>Sequencing ID: " + source.seq_id : "<br>No sequencing data"))
          .style("opacity", 0.9)
          .style("height", "auto")
          .style("left", event.pageX + 10 + "px")
          .style("top", event.pageY + 20 + "px");
      })
      .on("mouseleave", function (d) {
        self.clearSourceHighlight();
        tooltip.style("opacity", 0).style("height", 0);
      });
  }

  drawSrceWardOverlay(pt, pt_ward_start, pt_ward_end, source, y, x) {
    if (
      document.getElementById(
        `ward_overlay_${source.hospital_number}-${source.ward}`
      )
    ) {
      // Do not draw overlay if it already exists
      return;
    } else {
      // Draw overlay before index patient ward start
      this.svgCanvas
        .append("rect")
        .attr("class", "ward_overlay")
        .attr("id", `ward_overlay_${source.hospital_number}-${source.ward}`)
        .attr("ward_id", source.ward)
        .attr("x", x(pt.at_risk_start)) // Set the x-coordinate to the start of the x-axis
        .attr("y", y(source.label) - 2.5) // Position it at the top
        .attr("width", Math.max(x(pt_ward_start) - x(pt.at_risk_start), 0)) // Set the width to cover the remaining chart area
        .attr("height", y.bandwidth() + 5) // Set the height to cover the entire chart
        .style("fill", "white") // Make it invisible (no fill)
        .style("opacity", 0)
        .style("pointer-events", "none");

      // Draw overlay after index patient ward end
      this.svgCanvas
        .append("rect")
        .attr("class", "ward_overlay")
        .attr("ward_id", source.ward)
        .attr("x", x(pt_ward_end)) // Set the x-coordinate to the end of the x-axis
        .attr("y", y(source.label) - 2.5) // Position it at the top
        .attr("width", Math.max(x(pt.inf_start) - x(pt_ward_end), 0)) // Set the width to cover the remaining chart area
        .attr("height", y.bandwidth() + 5) // Set the height to cover the entire chart
        .style("fill", "white") // Make it invisible (no fill)
        .style("opacity", 0)
        .style("pointer-events", "none");
    }
  }

  drawSrcePlotOverlay(pt, y, source) {
    //console.log(pt);
    const { plot_start, at_risk_start, inf_start, plot_end } = pt;
    const contamEnd = new Date(
      source.inf_bar_end + this.props.contam_period * 24 * 60 * 60 * 1000
    );
    const x = this.x;

    // Check if source extends before at_risk_start and after inf_start
    const sourceStartTime = source.at_risk_start || plot_start;
    const sourceEndTime = contamEnd || plot_end;

    // Overlay before at_risk_start
    if (sourceStartTime < at_risk_start) {
      this.svgCanvas.append("rect")
        .attr("x", x(plot_start))
        .attr("width", x(at_risk_start) - x(plot_start))
        .attr("y", y(source.label))
        .attr("height", y.bandwidth())
        .style("fill", "white")
        .style("opacity", 0.65);
    }

    // Overlay after inf_start
    if (sourceEndTime > inf_start) {
      this.svgCanvas.append("rect")
        .attr("x", x(inf_start))
        .attr("width", x(plot_end) - x(inf_start))
        .attr("y", y(source.label))
        .attr("height", y.bandwidth())
        .style("fill", "white")
        .style("opacity", 0.65);
    }
  }

  endAxisOverlay(pt) {
    //required to cut off contamination triangles at end of plot - is just a white rectangle
    this.svgCanvas
      .append("rect")
      .attr("x", this.x(pt.plot_end)) // Set the x-coordinate to the end of the x-axis
      .attr(
        "y",
        this.state.height -
          this.state.ptHeight * this.state.nPt -
          this.state.nWards * this.state.spacer
      ) // Position it at the top
      .attr("width", 500) // Set the width to cover the remaining chart area
      .attr(
        "height",
        this.state.ptHeight * this.state.nPt +
          this.state.nWards * this.state.spacer
      ) // Set the height to cover the entire chart
      .style("fill", "white"); // Make it invisible (no fill)
  }

  drawVerticals(pt) {
    this.svgCanvas
      .append("line")
      .style("stroke", "black")
      .style("opacity", 0.4)
      .style("stroke-dasharray", "6, 6")
      .style("stroke-width", 1)
      .attr("x1", this.x(pt.at_risk_start))
      .attr("y1", 90)
      .attr("x2", this.x(pt.at_risk_start))
      .attr("y2", this.state.height);

    this.svgCanvas
      .append("line")
      .style("stroke", "black")
      .style("opacity", 0.4)
      .style("stroke-dasharray", "6, 6")
      .style("stroke-width", 1)
      .attr("x1", this.x(pt.at_risk_end))
      .attr("y1", 90)
      .attr("x2", this.x(pt.at_risk_end))
      .attr("y2", this.state.height);
  }

  drawHorizontal() {
    this.svgCanvas
      .append("line")
      .style("stroke", "black")
      .style("stroke-width", 1)
      .style("stroke-width", 1)
      .style("opacity", 0.2)
      .attr("x1", 20)
      .attr("y1", this.state.locationHeight + 15 + this.state.ptHeight * 2)
      .attr("x2", this.state.width)
      .attr("y2", this.state.locationHeight + 15 + this.state.ptHeight * 2);
  }

  drawTestResultsAndText(tests, name) {
    let x = this.x;
    let testHeight = this.state.testHeight;
    const colors = this.state.colors;

    var tooltip = d3
    .select("body")
    .append("tooltip")
    .style("opacity", 0)
    .style("background-color", this.state.colors.tooltip_background)
    .style("border-radius", "5px")
    .style("border-color", this.state.colors.tooltip_border)
    .style("padding", "5px")
    .style("color", this.state.colors.tooltip_text)
    .style("position", "absolute")
    .style("font-size", "12.5px")
    .style("height", 0);

    this.svgCanvas
      .selectAll("testResultsGroup")
      .data(tests)
      .enter()
      .append("g")
      .attr("transform", d => `translate(${x(d.collectdt)}, ${testHeight})`)
      .each(function(d) {
        let group = d3.select(this);

        // Draw test result circle
        group.append("circle")
          .attr("stroke", d => {
            if (d.detected > 0 && d.test_type === "Toxin") {
              return colors.test_pos_toxin_border;
            } else if (d.detected > 0 && d.test_type === "GDH") {
              return colors.test_pos_gdh_border;
            } else {
              return colors.test_neg_border;
            }
          })
          .attr("r", 10)
          .attr("fill", d => {
            if (d.detected > 0 && d.test_type === "Toxin") {
              return colors.test_pos_toxin;
            } else if (d.detected > 0 && d.test_type === "GDH") {
              return colors.test_pos_gdh;
            } else {
              return colors.test_neg;
            }
          })
          .on("mousemove", function (event, d) {
            tooltip
              .style("left", event.pageX + 10 + "px")
              .style("top", event.pageY + 20 + "px");
          })
          .on("mouseleave", function (event, d) {
            tooltip.style("opacity", 0).style("height", 0);
          })
          .on("mouseover", function (event, d) {
            tooltip
              .html('Test Type: ' + d.test_type + '<br>Tested: ' + formatDateNumeric(d.collectdt) + '<br>Result: ' + (d.detected > 0 ? '<font color=#db8380><b>Positive</b></font>' : '<font color=#94aac7><b>Negative</b></font>'))
              .style("opacity", 0.9)
              .style("height", "auto");
          });

        // Draw test result text
        group.append("text")
          .attr("y", 4)
          .attr("text-anchor", "middle")
          .attr("font-size", 14)
          .attr("fill", colors.test_text)
          .text(d => d.detected > 0 ? "+" : "-")
          .style("pointer-events", "none");
      });

    // Append the header text
    this.svgCanvas
      .append("text")
      .attr("x", 20)
      .attr("y", testHeight + 3)
      .attr("font-size", 16)
      .attr("font-weight", 500)
      .style("text-anchor", "start")
      .text(name.split(" ")[0] + "'s Test Result(s):");
  }

  drawPatientLocations(locations, name) {
    this.svgCanvas
      .append("text")
      .attr("x", 20)
      .attr("y", this.state.locationHeight + this.state.ptHeight / 2 + 3)
      .attr("font-size", 16)
      .attr("font-weight", 500)
      .style("text-anchor", "start")
      .text(name.split(" ")[0] + "'s Location(s):");

    locations.sort((a, b) => a.start - b.start);

    // const uniqueLocations = [...new Set(locations.map((d) => d.ward))];

    // let wardColorScale = d3
    //   .scaleOrdinal()
    //   .domain(uniqueLocations)
    //   .range(this.state.wardColors);

    this.lastLabelPosition = "above";
    this.lastLabelHeight = 1;

    for (let i = 0; i < locations.length; i++) {
      this.drawLocationBars(locations[i], name);
    }
  }

  // drawLocationBars(location, wardColorScale) {
  //   var tooltip = d3
  //     .select("body")
  //     .append("tooltip")
  //     .style("opacity", 0)
  //     .style("background-color", "black")
  //     .style("border-radius", "5px")
  //     .style("padding", "5px")
  //     .style("color", "white")
  //     .style("position", "absolute")
  //     .style("font-size", "13px")
  //     .style("height", 0);

  //   let x = this.x;
  //   let self = this;

  //   //console.log('code', location.ward_code);

  //   this.svgCanvas
  //     .append("rect")
  //     .attr("ward", location.ward)
  //     .attr("x", x(location.start))
  //     .attr("y", this.state.locationHeight)
  //     .attr("width", x(location.end) - x(location.start) + "px")
  //     .attr("height", this.state.ptHeight)
  //     .attr("fill", wardColorScale(location.ward))
  //     .on("mousemove", function (event, d) {
  //       tooltip
  //         .style("left", event.pageX + 10 + "px")
  //         .style("top", event.pageY + 20 + "px");
  //     })
  //     .on("mouseleave", function (event, d) {
  //       self.clearWardHighlight();
  //       tooltip.style("opacity", 0).style("height", 0);
  //     })
  //     .on("mouseover", function (event, d) {
  //       self.highlightWardSegments(d3.select(this).attr("ward"));
  //       tooltip
  //         .html(location.ward)
  //         .style("opacity", 0.8)
  //         .style("height", "auto");
  //     });

  //   this.svgCanvas
  //     .append("text")
  //     .attr("font-size", 12.5)
  //     .attr("x", x(location.start) + (x(location.end) - x(location.start)) / 2)
  //     .attr("y", this.state.locationHeight + this.state.ptHeight / 2 + 5)
  //     .style("text-anchor", "middle")
  //     .text(function () {
  //       if (x(location.end) - x(location.start) < location.ward_code.length * 10) {
  //         return ""; //hide label if too small to fit
  //       } else {
  //         return location.ward_code;
  //       }
  //     })
  //     .on("mousemove", function (event, d) {
  //       tooltip
  //         .style("left", event.pageX + 10 + "px")
  //         .style("top", event.pageY + 20 + "px");
  //     })
  //     .on("mouseleave", function (event, d) {
  //       tooltip.style("opacity", 0).style("height", 0);
  //     })
  //     .on("mouseover", function (event, d) {
  //       tooltip
  //         .html(location.ward)
  //         .style("opacity", 0.8)
  //         .style("height", "auto");
  //     });
  // }

  drawLocationBars(location) {
    const wardColor = this.getWardColor(location.ward);

    var tooltip = d3
      .select("body")
      .append("tooltip")
      .style("opacity", 0)
      .style("background-color", "black")
      .style("border-radius", "5px")
      .style("padding", "5px")
      .style("color", "white")
      .style("position", "absolute")
      .style("font-size", "12.5px")
      .style("height", 0);

    let x = this.x;
    let self = this;
    let rectWidth = x(location.end) - x(location.start);
    let labelPlacement =
      this.state.locationHeight + this.state.ptHeight / 2 + 5;
    let labelText = location.ward_code;
    let labelWidth = labelText.length * 8.5; // Change if text overflowing

    this.svgCanvas
        .append("rect")
        .attr("class", "location_bar")
        .attr("ward", location.ward)
        .attr("x", x(location.start))
        .attr("y", this.state.locationHeight)
        .attr("width", rectWidth + "px")
        .attr("height", this.state.ptHeight)
        .attr("fill", wardColor)
        .attr("opacity", 0.9)
        .on("mousemove", function(event, d) {
            tooltip
                .style("left", event.pageX + 10 + "px")
                .style("top", event.pageY + 20 + "px");
        })
        .on("mouseleave", function(event, d) {
            self.clearWardHighlight();
            tooltip.style("opacity", 0).style("height", 0);
        })
        .on("mouseover", function(event, d) {
            self.highlightWardSegments(d3.select(this).attr("ward"));
            tooltip
                .html("<b>" + location.ward + "</b> [" + location.ward_code + "] <br>Specialty: " + location.specialty + "<br>Hospital: " + location.hospital)
                .style("opacity", 0.9)
                .style("height", "auto")
                .style("background-color","#132f52");
        });

    // Check if space is too small for the label
    if (rectWidth < labelWidth) {
      let labelY, lineStartY, lineEndY;

      if (this.lastLabelPosition === "above") {
        // Place this label below the bar
        labelY =
          this.state.locationHeight +
          this.state.ptHeight +
          15 -
          10 * ((Math.ceil(this.lastLabelHeight / 2) % 2) - 1); // Below the bar
        lineStartY = this.state.locationHeight + this.state.ptHeight;
        lineEndY = labelY - 10;
        this.lastLabelPosition = "below"; // Update the last label position
        this.lastLabelHeight += 1; // Update the last label height
      } else {
        // Place this label above the bar
        labelY =
          this.state.locationHeight -
          5 +
          10 * ((Math.ceil(this.lastLabelHeight / 2) % 2) - 1); // Above the bar
        lineStartY = this.state.locationHeight;
        lineEndY = labelY + 2;
        this.lastLabelPosition = "above"; // Update the last label position
        this.lastLabelHeight += 1; // Update the last label height
      }

      // Draw connecting line
      this.svgCanvas
        .append("line")
        .style("stroke", "black")
        .style("opacity", 0.6)
        .attr("x1", x(location.start) + rectWidth / 2)
        .attr("y1", lineStartY)
        .attr("x2", x(location.start) + rectWidth / 2)
        .attr("y2", lineEndY)
        .attr("stroke-width", 1);

      // Plot label
      this.svgCanvas
        .append("text")
        .attr("font-size", 12)
        .attr("x", x(location.start) + rectWidth / 2)
        .attr("y", labelY)
        .style("text-anchor", "middle")
        .style("pointer-events", "none")
        .text(labelText);
    } else {
      // If enough space, plot label in the default position
      this.svgCanvas
        .append("text")
        .attr("font-size", 12)
        .attr("x", x(location.start) + rectWidth / 2)
        .attr("y", this.state.locationHeight + this.state.ptHeight / 2 + 5)
        .style("text-anchor", "middle")
        .style("pointer-events", "none")
        .text(labelText);
      // Alternate label position for the next bar
      this.lastLabelPosition =
        this.lastLabelPosition === "above" ? "below" : "above";
      // Reset label height
      this.lastLabelHeight = 1;
    }
  }

  insertMenu() {
    d3.select(".overlap-container")
      .append("select")
      .attr("id", "name-menu")
      .style("padding", "3px")
      .style("position", "relative")
      .style("bottom", "90px")
      .style("left", "0px");
  }

  buildMenu = () => {
    d3.select("#name-menu")
      .selectAll("myOptions")
      .data(["--"])
      .enter()
      .append("option")
      .text((d) => {
        return d;
      });
    d3.select("#name-menu")
      .selectAll("myOptions")
      .data(this.state.popped_sources)
      .enter()
      .append("option")
      .text((d) => {
        return d.ward + ":" + " " + d.firstname + " " + d.surname;
      })

      .attr("value", (d) => {
        return this.state.popped_sources.findIndex((element) => {
          if (
            element.firstname === d.firstname &&
            element.surname === d.surname
          ) {
            return true;
          }
        });
      });

    d3.select("#name-menu").on("change", async function (d) {
      var selectedOption = d3.select(this).property("value");
      await recoverSource(selectedOption);
    });

    const recoverSource = async (popped_source_idx) => {
      var source = this.state.popped_sources[popped_source_idx];
      this.state.popped_sources.splice(popped_source_idx, 1);
      const ward = source.ward;
      let ward_index = this.state.source_list.findIndex((element) => {
        if (element.ward === ward) {
          return true;
        }
      });
      var source_list = [...this.state.source_list];
      source_list[ward_index].sources = [
        ...source_list[ward_index].sources,
        source,
      ];
      // source_list[ward_index].sources.push(source);
      let nPtWard = [];
      for (let i = 0; i < source_list.length; i++) {
        if (i === 0) {
          nPtWard[i] = source_list[i].sources.length;
        } else {
          nPtWard[i] = source_list[i].sources.length + nPtWard[i - 1];
        }
      }

      this.setState({
        source_list: source_list,
      });
      // update source count for correct y axis spacing
      this.updateSourceCount(source_list);
    };
  };

  insertHelpToggle() {
    d3.select(".overlap_plot")
      .append("button")
      .attr("id", "help-toggle")
      .style("padding", "3px")
      .style("position", "sticky")
      .style("width", "20px")
      .style("height", "20px")
      .style("bottom", "615px")
      .style("left", "960px")
      .style("display", "flex")
      .style("border-radius", "50%")
      .text("i")
      .style("font-size", "15px")
      .style("align-items", "center")
      .style("justify-content", "center")
      .on("click", () => {
        toggleHelp();
      });

    const toggleHelp = () => {
      if (this.state.help_on === false) {
        this.setState({ help_on: true });
      } else {
        this.setState({ help_on: false });
      }
    };
  }

  updateMouseLine(pt) {
    const svg = this.svgCanvas;
    const margin = this.state.margin;
    const height = this.state.height;
    const lowerPosHeight = this.state.height - 10;
    const upperPosHeight = this.state.locationHeight + 75;
    const width = this.state.width;
    const x = this.x;

    //Draw mouse line & date
    let mouseG = svg.select(".mouse-over-effects");
    if (mouseG.empty()) {
      mouseG = svg
        .append("g")
        .attr("class", "mouse-over-effects")
        .style("pointer-events", "none");

      mouseG
        .append("path")
        .attr("class", "mouse-line")
        .style("stroke", this.state.colors.mouse_over_color)
        .style("stroke-width", "2px")
        .style("opacity", "0");

      mouseG
        .append("rect")
        .attr("class", "mouse-date-box")
        .attr("y", lowerPosHeight - 12)
        .attr("height", 15)
        .attr("width", 105)
        .style("fill", this.state.colors.mouse_over_color)
        .style("opacity", "0");

      mouseG
        .append("text")
        .attr("class", "mouse-date-text")
        .attr("y", lowerPosHeight)
        .attr("text-anchor", "right")
        .attr("fill", "white")
        .attr("font-size", 12.5)
        .style("opacity", "0");
    }

    svg
      .on("mousemove", (d) => {
        const mouse = d3.pointer(d);
        const mouseX = mouse[0];
        const mouseY = mouse[1];

        let yPos =
          mouseY < lowerPosHeight + (upperPosHeight - lowerPosHeight) / 2
            ? upperPosHeight
            : lowerPosHeight;

        if (
          mouseX > margin.left &&
          mouseX < width &&
          mouseY > margin.top &&
          mouseY < height + margin.top
        ) {
          const firstPosDate = parseDate(pt.first_positive);
          const mouseDate = x.invert(mouseX); // convert mouse position to date
          const dateFormat = d3.timeFormat("%d-%b");
          var dateLabel = "";

          if (mouseDate >= firstPosDate) {
            dateLabel = dateFormat(firstPosDate) + " (Today)";
          } else {
            dateLabel =
              dateFormat(mouseDate) +
              " (" +
              -Math.floor((mouseDate - firstPosDate) / (1000 * 60 * 60 * 24)) +
              "d ago)";
          }

          mouseG
            .select(".mouse-line")
            .style("opacity", "0.6")
            .attr("d", function () {
              let d = "M" + mouseX + "," + height;
              d += " " + mouseX + "," + 0;
              return d;
            });

          mouseG
            .select(".mouse-date-text")
            .style("opacity", "1")
            .attr("x", mouseX + 2)
            .attr("y", yPos)
            .text(dateLabel);

          mouseG
            .select(".mouse-date-box")
            .style("opacity", "0.75")
            .attr("x", mouseX)
            .attr("y", yPos - 12);
        } else {
          mouseG.select(".mouse-line").style("opacity", "0");

          mouseG.select(".mouse-date-text").style("opacity", "0");

          mouseG.select(".mouse-date-box").style("opacity", "0");
        }
      })
      .on("mouseout", function () {
        mouseG.select(".mouse-line").style("opacity", "0");

        mouseG.select(".mouse-date-text").style("opacity", "0");

        mouseG.select(".mouse-date-box").style("opacity", "0");
      });
  }

  drawChart(data) {
    // this.svgCanvas.selectAll("*").remove();
    // this.svgCanvas.style("width", this.state.width + "px");
    this.drawXAxis(data.pt);
    this.drawPtAtRisk(data.pt);
    this.drawPtInfectious(data.pt);
    this.sourceHeaderBlock(data.pt);
    this.constructWardBlocks(data.pt, data.locations);
    this.drawVerticals(data.pt);
    this.drawHorizontal();
    this.drawTestResultsAndText(data.tests, data.pt.name);
   //this.drawTestResults(data.tests, data.pt.name);
    // for (let i = 0; i < data.tests.length; i++) {
    //   this.drawTestText(data.tests[i]);
    // }
    this.drawPatientLocations(data.locations, data.pt.name);
    //this.buildMenu();
    this.clickSource(data.source_list);
    this.endAxisOverlay(data.pt);
    this.updateMouseLine(data.pt);
  }

  render() {
    const containerStyles = {
      display: "flex",
      width: "100%",
      position: "relative",
      overflowX: "auto",
    };
  
    const buttonContainerStyles = {
      position: "absolute",
      left: "10px",
      bottom: "10px"
    };

    const buttonStyles = {
      width: "30px",
      height: "30px",
      padding: "0",
      margin: "2px",
      fontSize: "18px",
      textAlign: "center",
      size: "sm",
      borderRadius: "10px",
      borderColor: "grey",
      cursor: "pointer",
    };

    const longButtonStyles = {
      height: "30px",
      padding: "2",
      margin: "2px",
      fontSize: "14px",
      textAlign: "center",
      size: "sm",
      borderRadius: "10px",
      borderColor: "grey",
      cursor: "pointer",
    };
  
    return (
      <div style={containerStyles}>
        <div ref={this.canvas} style={{ width: "100%", height: "100%", marginBottom: "12px"}}></div>
        <div style={buttonContainerStyles}>
          <Button
            variant="light"
            size="sm"
            style={buttonStyles}
            onClick={() => this.changeWidthScale(0.1)}
            onMouseDown={() => this.startHold(0.1)}
            onMouseUp={this.clearHoldInterval}
            onMouseLeave={this.clearHoldInterval}
          >
            +
          </Button>
          <Button
            variant="light"
            size="sm"
            style={buttonStyles}
            onClick={() => this.changeWidthScale(-0.1)}
            onMouseDown={() => this.startHold(-0.1)}
            onMouseUp={this.clearHoldInterval}
            onMouseLeave={this.clearHoldInterval}
          >
            -
          </Button>
          <Button variant="light" size="sm" style={buttonStyles} onClick={() => this.changeWidthScale(1, true)}>
            ↻
          </Button>
          {/* Button to download json */}
          {/* <Button variant="light" size="sm" style={longButtonStyles} onClick={this.downloadJSON}>
            Download chart data (.json)
          </Button> */}
        </div>
      </div>
    );
  }
}

export default OverlapsPlot;
